if (!customElements.get("widget-zendesk-personal-shopper"))
  customElements.define(
    "widget-zendesk-personal-shopper",
    class WidgetZendeskPersonalShopper extends HTMLElement {
      toLogger: boolean = true
      cartIdCustomFieldId: number
      discountCodeCustomFieldId: number
      productNameCustomFieldId: number
      constructor() {
        super();
        this.toLogger = this.toLogger || sessionStorage.getItem('insider:debug:widget-zendesk-personal-shopper') === 'true' ? true : false;
        this.init()
        this.cartIdCustomFieldId = this.dataset.cartIdCustomFieldId ? parseInt(this.dataset.cartIdCustomFieldId) : 43112175326996;
        this.discountCodeCustomFieldId = this.dataset.discountCodeCustomFieldId ? parseInt(this.dataset.discountCodeCustomFieldId) : 43112255164180;
        this.productNameCustomFieldId = this.dataset.productNameCustomFieldId ? parseInt(this.dataset.productNameCustomFieldId) : 43303511358612;

      }

      log = Object.assign(
        (...args: any[]) => {
        if (this.toLogger)
            console.log("%c[DEBUG]", "color:red;", `[WidgetZendesk]`, ...args);
        },
        {
          error: (message: string, ...args: any[]) => {
              console.error(`%c[WidgetZendesk] ${message}`, "color:red;", ...args);
          },
          warn: (message: string, ...args: any[]) => {
            if (this.toLogger)
              console.warn(`%c[WidgetZendesk] ${message}`, "color:orange;", ...args);
          },
          info: (...args: any[]) => {
            if (this.toLogger)
              console.info("%c[INFO]", "color:blue;", `[WidgetZendesk]`, ...args);
          }
        }
      );

      async connectedCallback(): Promise<void> {
        try {
            this.pushZeCommands('messenger', 'show');
            this.repositionWidget();
            this.toggleWidgetByMinicartState();
        } catch (error) {
          this.log.error(`Error to connectedCallback`, error);
        }
      }

      private zeCommandsQueue: Array<{type: string, command: string}> = [];
      private pushZeCommands(type: string, command: string){
        this.zeCommandsQueue.push({type, command});
        this.flushZeCommands();
      }

      private flushZeCommands() {
        if (typeof window.zE === 'function') {
          this.zeCommandsQueue.forEach(cmd => {
            window.zE(cmd.type, cmd.command);
          });
          this.zeCommandsQueue = [];
        }
      }

      private init(){
        // INJEÇÃO GLOBAL DE DADOS PARA ZENDESK
        this.injectGlobalZendeskData();
        document.getElementById('ze-snippet')?.addEventListener('load', () => this.flushZeCommands());
      }

      private async injectGlobalZendeskData(): Promise<void> {
        setTimeout(async () => {
          const cartIdCustomFieldId = this.cartIdCustomFieldId;
	        const discountCodeCustomFieldId = this.discountCodeCustomFieldId;
	        const productNameCustomFieldId = this.productNameCustomFieldId;

          const activeCartId = await this.getActiveCartId();
          const activeDiscountCode = this.getActiveDiscountCode();
          const productName = this.getProductNameFromUrl();

          const customFields = [];

          if (activeCartId) {
            customFields.push({
              id: cartIdCustomFieldId,
              value: activeCartId,
            });
          }

          if (activeDiscountCode) {
            customFields.push({
              id: discountCodeCustomFieldId,
              value: activeDiscountCode,
            });
          }

          if (productName) {
            customFields.push({
              id: productNameCustomFieldId,
              value: productName,
            });
          }

          if (typeof window.zE === 'function' && customFields.length > 0) {
            window.zE('messenger:on', 'unreadMessages', async (count: number) => count == 1 && await this.refreshCartData());
            window.zE('messenger:set', 'conversationFields', customFields);
          } else {
            this.log.warn('Zendesk Web Widget not loaded yet or no custom fields to set.');
          }
          this.log.info('Zendesk injected custom fields', customFields);
        }, 2000);
      }

       private async refreshCartData(): Promise<void> {
        try {
          this.log.info('Cart refresh initiated');

          // Usar o método updateCart modificado sem abrir o drawer
          const cartDrawerElement = document.querySelector('cart-drawer') as HTMLElement & { updateCart: (openDrawer: boolean) => void };
          if (cartDrawerElement && typeof cartDrawerElement.updateCart === 'function') {
            cartDrawerElement.updateCart(false); // false = não abrir o drawer
            this.log.info('Cart updated silently using updateCart(false)');
          } else {
            this.log.warn('Cart drawer element not found');
          }
        } catch (error) {
          this.log.error('Cart refresh failed', error);
        }
      }

      private async getActiveCartId(): Promise<string|undefined> {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const cartId = cart.token;
          
          if (cartId && cartId.includes('?key=')) {
            return cartId;
          }

          this.log.warn('Cart ID has unexpected format');
        } catch (error) {
          this.log.warn('Erro ao buscar dados do carrinho:', error);
        }
      }

      private getActiveDiscountCode(): string|undefined {
        try {
          const couponData = sessionStorage.getItem("insider:cart:promotionCoupon");
          if (couponData) {
            const parsed = JSON.parse(couponData);
            if (parsed.code) {
              return parsed.code;
            }
            const discountDefault = parsed['discount_default'];
            if (discountDefault && discountDefault['discount'] && discountDefault['discount']['code']) {
              return discountDefault['discount']['code'];
            }
          }
        } catch (error) {
          this.log.warn('Erro ao buscar cupom padrão no sessionStorage:', error);
        }
      }

      private getProductNameFromUrl(): string|undefined {
        try {
          const url = window.location.pathname;

          const productMatch = url.match(/^\/products\/([^\/\?#]+)/);

          if (productMatch && productMatch[1]) {
            const productSlug = productMatch[1];
            return decodeURIComponent(productSlug.replace(/-/g, ' '));
          }
        } catch (error) {
          this.log.warn('Erro ao extrair nome do produto da URL:', error);
        }
      }

      private cartDrawerObserver?: MutationObserver;

      private repositionWidget(){
        const observer = new MutationObserver(() => {
          const launcher = document.getElementById('launcher');
          if (launcher) {
            launcher.style.marginBottom = '30px';
            observer.disconnect();
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      }

      private toggleWidgetByMinicartState() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer || this.cartDrawerObserver) return;

        this.cartDrawerObserver = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (cartDrawer.classList.contains('active')) {
                this.pushZeCommands('messenger', 'hide');
              } else {
                this.pushZeCommands('messenger', 'show');
              }
            }
          }
        });

        this.cartDrawerObserver.observe(cartDrawer, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    })